<template>
    <div class="main-content bg-gradient-gray vh-100 overflow-auto">
        <!-- Header -->
        <div class="header bg-secondary pb-8 pt-6 pb-lg-9 pt-lg-7">
            <div class="container pb-5">
                <div class="header-body">
                    <div class="row justify-content-center">
                        <div class="col-12">
                            <div class="row align-items-center">
                                <div class="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-end pr-sm-5 pb-5 pb-sm-0">
                                    <router-link slot="brand" to="/">
                                        <img src="img/brand/logo.png" height="65px"/>
                                    </router-link>
                                </div>
                                <div class="col-12 col-sm-6 border-left pl-sm-5 text-center text-sm-left">
                                    <p class="text-lead text-md mb-0">
                                        <span class="text-lg font-weight-bold">Bienvenido<br></span> 
                                        Portal para clientes
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100" style="height: 150px;">
                <svg class="bg-gradient-gray" x="0" y="0" viewBox="0 0 2560 300" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <ellipse cx="1100" cy="0" rx="1400" ry="290"  fill="#ffffff7a" />
                    <ellipse cx="1200" cy="0" rx="2500" ry="300"  fill="#ffffff7a" />
                    <ellipse cx="1400" cy="0" rx="1500" ry="280"  class="fill-secondary" />
                </svg>
            </div>
        </div>
        <!-- Page content -->
        <div class="container mt--8 pb-5" style="padding-top: 164px;">
            <slide-y-up-transition mode="out-in" origin="center top">
                <router-view></router-view>
            </slide-y-up-transition>
        </div>
        <footer class="py-5">
            
        </footer>
    </div>
</template>
<script>
  import { SlideYUpTransition } from 'vue2-transitions'
  //import firebase from 'firebase'
  //const currentUser = firebase.auth().currentUser;

  export default {
    name: 'auth-layout',
    components: {
      SlideYUpTransition
    },
    data() {
      return {
        year: new Date().getFullYear(),
        showMenu: false,
        //user: currentUser
      }
    }
  }
</script>
<style>
</style>
